import { useCallback } from 'react'
import { SendTransactionResult } from 'wagmi/actions'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { useCandyLockV2Contract } from 'hooks/useContract'

const useLockToken = () => {
  const { callWithGasPrice } = useCallWithGasPrice()
  const lockV2Contract = useCandyLockV2Contract()

  const onLock = useCallback(
    async (amount: string, duration: number, nftIds, rarities, proofs): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'lock',
        [amount, duration, nftIds, rarities, proofs]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  const onBuy = useCallback(
    async (lid: number): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'buy',
        [lid]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  const onClaim = useCallback(
    async (lid: number): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'claimReward',
        [lid]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  const onUnlock = useCallback(
    async (lid: number): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'unlock',
        [lid]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  const onTransfer = useCallback(
    async (lid: number, newOwner: string): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'transfer',
        [lid, newOwner]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  const onList = useCallback(
    async (lid: number, price: string): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'list',
        [lid, price]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  const onDelist = useCallback(
    async (lid: number): Promise<SendTransactionResult> => {
      return callWithGasPrice(
        lockV2Contract,
        'delist',
        [lid]
      )
    },
    [lockV2Contract, callWithGasPrice],
  )

  return {
    onBuy,
    onClaim,
    onDelist,
    onList,
    onLock,
    onTransfer,
    onUnlock
  }
}

export default useLockToken
